<template>
  <div class="relative">
    <VueLoading :active.sync="loading" :is-full-page="false" />
    <StatCard
      title="Backups"
      :value="totalBackups"
      :change="changePercentage"
      :isPositive="changePercentage >= 0"
      customClass="backups-stat-card"
    />
  </div>
</template>

<script>
import StatCard from './StatCard.vue'
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'BackupsStatCard',
  components: { StatCard, VueLoading },
  props: {
    id: {
      type: String,
      required: true
    },
    changePercentage: {
      type: [Number, String],
      default: 28.4
    }
  },
  computed: {
    ...mapGetters(['activeType'])
  },
  data () {
    return {
      loading: false,
      totalBackups: 0
    }
  },
  methods: {
    getSummary () {
      this.loading = true
      HTTP.get(`/backups/summary/${this.activeType}/${this.id}`)
        .then(response => {
          this.totalBackups = this.reduceChartData(response.data.summary, 'total')
        })
        .catch(error => {
          this.flashMessage.error({
            message: `Failed to get backups report : ${(error.response && error.response.data && error.response.data.error) || error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    formatChartData (data, type) {
      const dataArray = []
      for (const resource in data) {
        dataArray.push(data[resource][type])
      }
      return dataArray
    },
    reduceChartData (data, type) {
      return this.formatChartData(data, type).reduce((a, b) => a + b, 0)
    }
  },
  watch: {
    id: {
      immediate: true,
      handler () {
        this.getSummary()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/StatCards/BackupsStatCard.vue